import { useEffect, useState } from 'react';
import { AlertTriangle, RefreshCw, X } from 'lucide-react';
import { useI18n } from '../lib/i18n';
import { EVENTO_FALLO, type FalloDeCarga } from '../lib/fallos';

/**
 * La franja que aparece cuando una lista no pudo cargarse (ver lib/fallos.ts). Una sola por
 * clave (un poll que falla cada 30 s no apila treinta franjas), se cierra a mano o al reintentar,
 * y se va sola a los 20 s si nadie la toca.
 */
export function FalloDeCargaBar() {
  const { t } = useI18n();
  const [fallos, setFallos] = useState<FalloDeCarga[]>([]);

  useEffect(() => {
    const onFallo = (e: Event) => {
      const d = (e as CustomEvent<FalloDeCarga>).detail;
      if (!d?.clave) return;
      setFallos((prev) => [...prev.filter((f) => f.clave !== d.clave), d]);
    };
    window.addEventListener(EVENTO_FALLO, onFallo);
    const limpieza = window.setInterval(() => {
      setFallos((prev) => prev.filter((f) => Date.now() - f.at < 20_000));
    }, 5_000);
    return () => { window.removeEventListener(EVENTO_FALLO, onFallo); window.clearInterval(limpieza); };
  }, []);

  if (fallos.length === 0) return null;
  const quitar = (clave: string) => setFallos((prev) => prev.filter((f) => f.clave !== clave));
  return (
    <div role="status" aria-live="polite" style={{ position: 'fixed', left: 12, right: 12, bottom: 12, zIndex: 'var(--z-banner)', display: 'grid', gap: 6, pointerEvents: 'none' }}>
      {fallos.map((f) => (
        <div key={f.clave} style={{ pointerEvents: 'auto', margin: '0 auto', maxWidth: 560, width: '100%', background: 'var(--card)', border: '1px solid var(--red)', borderLeft: '4px solid var(--red)', borderRadius: 10, boxShadow: 'var(--shadow)', padding: '8px 10px', display: 'flex', alignItems: 'center', gap: 8, fontSize: 'var(--fs-sm)' }}>
          <AlertTriangle size={15} strokeWidth={1.75} style={{ color: 'var(--red)', flexShrink: 0 }} />
          <span style={{ flex: 1 }}>{t('load.failed', { what: t(`load.what.${f.clave}`) === `load.what.${f.clave}` ? f.clave : t(`load.what.${f.clave}`) })}</span>
          {f.reintentar && (
            <button type="button" className="btn sm" onClick={() => { quitar(f.clave); f.reintentar?.(); }}>
              <RefreshCw size={13} strokeWidth={1.75} /> {t('common.retry')}
            </button>
          )}
          <button type="button" className="btn ghost sm" aria-label={t('common.close')} title={t('common.close')} onClick={() => quitar(f.clave)}><X size={13} strokeWidth={1.75} /></button>
        </div>
      ))}
    </div>
  );
}
